var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"preload":"none","poster":_vm.posterUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }